import React from "react";
import { Phone, MessageSquare, FileText, Bell, StickyNote, Zap } from "lucide-react";
import { getNextBestAction } from "../../utils/crmNextBestAction";

const ICONS = {
  call: Phone,
  follow_up: Bell,
  send_quote: FileText,
  schedule: Bell,
  note: StickyNote,
  whatsapp: MessageSquare,
};

const CrmNextBestAction = ({ lead, compact = false }) => {
  const action = getNextBestAction(lead);
  if (!action) return null;

  const Icon = ICONS[action.key] || Zap;

  return (
    <div
      className={`crm-nba crm-nba--${action.priority}${compact ? " crm-nba--compact" : ""}`}
      title={action.reason}
    >
      <Icon size={compact ? 12 : 14} aria-hidden />
      <span className="crm-nba__label">{action.label}</span>
      {!compact && <span className="crm-nba__reason">{action.reason}</span>}
    </div>
  );
};

export default CrmNextBestAction;
